import { default as axios } from './http';


class SiteWorksAPI {

    getSiteWorks = async () => {
      // Fetch tarps from API
      console.log('Fetching site-works from API...')
      const url = '/api/v1/obhm/site-works/';
      const response = await axios.get(url)
      return response
    }

    createSiteWorks = async (data) => {
      // Create tarping works in API
      const url = '/api/v1/obhm/site-works/';
      const options = {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          }
      }
      const response = await axios.post(url, data, options)
      return response
    }

}

export default SiteWorksAPI;